<template>
  <main>
    <Header />
    <router-view />
    <Footer />
    <el-backtop></el-backtop>
  </main>
</template>

<script>
import Header from './Header';
import Footer from './Footer';

export default {
  name: 'Layout',
  mounted() {

  },
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss">
  @import "~animate.css/animate.css";
  @import "~@fortawesome/fontawesome-free/css/all.css";
  @import "../../styles/bootstrap";
  @import "../../styles/element";
  @import "../../styles/vendor/icon-line/css/simple-line-icons.css";
  @import "../../styles/vendor/icon-line-pro/style.css";
  @import "../../styles/unify-core.css";
  @import "../../styles/unify-components.css";
  @import "../../styles/unify-globals.css";
  @import "../../styles/app";
</style>
